<color-box 
    [color]="color" 
    class="size-xs mr3" 
    title="{{name}}">
</color-box>
{{name}}